<template>
    <div id="impressum">
        <ruth-header :tickets="false"></ruth-header>
        <div id="container" class="nobackgroundimg">
            <div id="content">
                <h1 class="ticketsheading">DVD Making-Of</h1>
                <h2>Tut uns leid - das Making-Of ist leider erst in Kürze verfügbar.</h2>
            </div>
            <social-media></social-media>
            <ruth-footer></ruth-footer>
        </div>
    </div>
</template>

<script>
    import ruthHeader from './GlobalSegments/Header'
    import socialMedia from './GlobalSegments/SocialMedia'
    import ruthFooter from './GlobalSegments/Footer'

    export default {
        name: 'DvdMakingOf',
        components: {
            ruthHeader,
            socialMedia,
            ruthFooter
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/DvdMakingOf.vue